import { createContext, PropsWithChildren, useCallback, useState } from "react"
import { Product } from "../api/types"
import { apiProductIndexGet } from "../api/product/index/get";
import { useNavigate } from "react-router-dom";
import useAsyncEffect from "use-async-effect";

type SessionState = {
  products: Product[];
  productsLoading: boolean;
  getProducts: () => Promise<void>;
  setProducts: (products: Product[]) => void;
}

const initialState = {
  products: [],
  productsLoading: true,
  getProducts: async () => {},
  setProducts: () => {},
}

export const SessionContext = createContext<SessionState>(initialState);

export const SessionProvider = ({ children }: PropsWithChildren) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [productsLoading, setProductsLoading] = useState(true);

  const navigate = useNavigate();

  /**
   * Redirect the user to the homepage if they already have a sign-in session.
   */
  const getProducts = useCallback(async () => {
    setProductsLoading(true);
    const response = await apiProductIndexGet();
    // Checks response is fetched and is valid
    if (response && response.status === 200) {
      setProducts(Array.isArray(response.data) ? response.data : []);
    }
    // Redirect to log in page if not logged in to valid account
    // No response data means that the issue isn't with fetching the assets
    else if (response && ((response.status === 404 && !(response.data)) || response.status === 401)) {
      navigate("/login");
    }
    else {
      setProducts([]);
    }

    setProductsLoading(false);
  }, [navigate]);

  useAsyncEffect(async () => {
    await getProducts();
  }, []);

  return (
    <SessionContext.Provider value={{ products, productsLoading, getProducts, setProducts }}>
      {children}
    </SessionContext.Provider>
  );
}
